"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Search = void 0;
const react_1 = __importDefault(require("react"));
exports.Search = (props) => {
    return (react_1.default.createElement("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", width: "11", height: "11", fill: "none", viewBox: "0 0 11 11" }, props),
        react_1.default.createElement("path", { fill: "#666", d: "M11 9.727L7.772 6.504A4.22 4.22 0 100 4.22a4.22 4.22 0 006.504 3.552l3.223 3.222L11 9.727zM1.136 4.22A3.092 3.092 0 014.22 1.136 3.088 3.088 0 017.305 4.22a3.085 3.085 0 11-6.17 0z" })));
};
